import { app } from '../../../../../app';
import { Controller } from './add-shared-password.controller';

app.component('companySharingCenterSharedPasswordsAdd', {
    bindings: {
		publicServicesWithSso$:'<',
        companyId: '<',
        copyAccount: '<',
    },
    controller: Controller,
    templateUrl: require('./add-shared-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/add/add-shared-password.component.js